import * as React from 'react';
import { FromToControl } from '../../../../../common/components/from_to_control';
import { IJsonQueryRangeValue } from '../../../../../json_query';

const styles = require('./index.css');

export interface IDirectionsModalHeaderProps {
  fromMKAD: IJsonQueryRangeValue;

  onChangeMin(value: number | undefined): void;
  onChangeMax(value: number | undefined): void;
}

export class DirectionsModalHeader extends React.Component<IDirectionsModalHeaderProps> {
  public render() {
    const { fromMKAD, onChangeMin, onChangeMax } = this.props;

    return (
      <div className={styles['header']}>
        <span className={styles['before']}>От МКАД:</span>
        <div className={styles['inputs']}>
          <FromToControl
            from={{
              disableNegative: true,
              value: fromMKAD.gte,
              onValueChange: onChangeMin,
            }}
            to={{
              disableNegative: true,
              value: fromMKAD.lte,
              onValueChange: onChangeMax,
            }}
          />
        </div>
        <span className={styles['after']}>км</span>
      </div>
    );
  }
}
